import { useMutation, useQueryClient } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

export const useExpiredRequestsCleanup = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async () => {
      const { data, error } = await supabase
        .rpc('cleanup_expired_requests');

      if (error) throw error;
      return data;
    },
    onSuccess: (data) => {
      // Invalidate all class request queries to refresh the UI
      queryClient.invalidateQueries({ queryKey: ['instructor-requests'] });
      queryClient.invalidateQueries({ queryKey: ['instructor-pending-requests-count'] });
      queryClient.invalidateQueries({ queryKey: ['student-requests'] });
      
      console.log('Expired requests cleanup:', data);
    },
    onError: (error) => {
      console.error('Error cleaning up expired requests:', error);
    }
  });
};

